import { render, staticRenderFns } from "./current-event.vue?vue&type=template&id=20ba0d69&scoped=true&"
import script from "./current-event.vue?vue&type=script&lang=js&"
export * from "./current-event.vue?vue&type=script&lang=js&"
import style0 from "./current-event.vue?vue&type=style&index=0&id=20ba0d69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba0d69",
  null
  
)

export default component.exports